<template>
  <div>
    <v-card
      v-for="(section, index) in sections"
      :id="section.slug"
      :key="section.id"
      :class="cardClass"
    >
      <div :class="headerClass">
        <component :is="headingTag" :class="headingClass">
          {{ sectionNumber(index) }} {{ section.title }}
        </component>
      </div>
      <div
        :class="contentClass"
        v-if="section.bodyHtml"
        v-html="renderContent(section.bodyHtml)"
      />
      <user-guide-section-tree
        v-if="section.children && section.children.length"
        :sections="section.children"
        :level="level + 1"
        :prefix="`${sectionNumber(index)}.`"
        :render-content="renderContent"
      />
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'user-guide-section-tree',
  props: {
    sections: {
      type: Array,
      default: () => []
    },
    level: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ''
    },
    renderContent: {
      type: Function,
      required: true
    }
  },
  computed: {
    cardClass() {
      return this.level === 0
        ? 'section-first'
        : this.level === 1
          ? 'section-second'
          : 'section-third'
    },
    headerClass() {
      return this.level === 0
        ? 'section-first-header'
        : this.level === 1
          ? 'section-second-header'
          : 'section-third-header'
    },
    contentClass() {
      return this.level === 0
        ? 'section-first-content'
        : this.level === 1
          ? 'section-second-content'
          : 'section-third-content'
    },
    headingTag() {
      return this.level === 0 ? 'h3' : this.level === 1 ? 'h4' : 'h5'
    },
    headingClass() {
      return this.level === 0
        ? 'section-first-title'
        : this.level === 1
          ? 'section-second-title'
          : 'section-third-title'
    }
  },
  methods: {
    sectionNumber(index) {
      return `${this.prefix}${index + 1}`
    }
  }
}
</script>

<style lang="scss" scoped>
.section-first {
  margin: 24px 0;
  overflow: hidden;

  &-header {
    background-color: $blue-color-bg;
    padding: 8px 24px;
  }

  &-content {
    padding: 16px 16px 20px;
  }
}

.section-second {
  &-header {
    background-color: $bg-primary-color;
    padding: 8px 24px 8px 32px;
  }

  &-content {
    padding: 16px 16px 20px 32px;
  }
}

.section-third {
  &-header {
    background-color: #edffcd;
    padding: 8px 24px 8px 40px;
  }

  &-content {
    padding: 16px 16px 20px 40px;
  }
}

.section-first-title,
.section-second-title,
.section-third-title {
  color: $link-color;
  margin: 0;
  text-transform: uppercase;
}

.section-first-title {
  font-size: 2rem;
  letter-spacing: 0.75px;
}

.section-second-title {
  font-size: 1.25rem;
  letter-spacing: 0.5px;
}

.section-third-title {
  font-size: 1rem;
  letter-spacing: 0.25px;
}

.section-first-content,
.section-second-content,
.section-third-content {
  :deep(ol),
  :deep(ul) {
    margin-bottom: 0;
    padding-left: 18px;
  }

  :deep(li) {
    margin-bottom: 6px;
  }

  :deep(p:last-child) {
    margin-bottom: 0;
  }
}
</style>
